package dev.lingvo.site.components.studio.fonts

import androidx.compose.runtime.Composable
import dev.lingvo.site.components.localeLabel
import dev.lingvo.site.i18n.t
import dev.lingvo.site.i18n.trf
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Progress
import org.jetbrains.compose.web.dom.Text

/** One progress surface for early prefetch and the blocking compose wait. Bytes are not known. */
@Composable
fun FontDownloadProgress(progress: FontLoadProgress) {
    val current = progress.current
    Div(attrs = { attr("role", "status"); attr("aria-live", "polite"); attr("aria-atomic", "true"); attr("data-font-progress", "") }) {
        val detail = if (current == null) t("studio.fonts.font_download_progress.screenshot_fonts_are_ready", "Screenshot fonts are ready.")
            else trf("screenshots.compose.font_download", "Downloading fonts for {language}… {family}",
                "language" to localeLabel(current.locale, ""), "family" to current.family)
        P { Text(detail) }
        Progress(attrs = {
            attr("max", progress.total.coerceAtLeast(1).toString())
            attr("value", progress.done.toString())
            attr("aria-label", detail)
        })
        if (progress.attempt > 1) P { Text(t("studio.fonts.font_download_progress.the_download_is_taking_longer_retrying", "The download is taking longer. Retrying automatically…")) }
    }
}
